import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function TestimonialSection() {
  const testimonials = [{
    name: 'Laura Martínez',
    role: 'Prof. Secundaria, Buenos Aires',
    text: 'Antes me quedaba hasta las 2 de la mañana buscando actividades. Con este pack, en 10 minutos tengo la semana resuelta. Es literal un salvavidas.',
    initial: 'L'
  }, {
    name: 'Carolina Vega',
    role: 'Instituto Privado, Córdoba',
    text: 'Lo que más me gusta es el orden. No son actividades sueltas, es un sistema. Mis alumnos notaron la diferencia y yo estoy mucho más tranquila.',
    initial: 'C'
  }, {
    name: 'Mariana Ruiz',
    role: 'Clases Particulares, Rosario',
    text: 'La inversión se paga sola con el tiempo que ahorrás. Dejé de improvisar y ahora entro a mis clases segura. El material es excelente.',
    initial: 'M'
  }, {
    name: 'Andrea Fernández',
    role: 'Primaria y Secundaria, Mendoza',
    text: 'Estaba a punto de dejar horas porque no daba abasto. Este pack me devolvió las ganas de enseñar. Simplemente gracias.',
    initial: 'A'
  }, {
    name: 'Sofía Benítez',
    role: 'Prof. Inglés, La Plata',
    text: 'Increíble la cantidad de material. Los bonos son un plus gigante. Si sos profe y estás cansada, necesitás esto sí o sí.',
    initial: 'S'
  }];
  return <section className="py-12 bg-gray-50" data-id="element-187">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-188">
        <div className="text-center mb-16" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-190">
            Docentes reales que recuperaron su vida
          </h2>
          <p className="text-gray-600" data-id="element-191">
            Ellas también estaban sobrecargadas. Hoy enseñan diferente.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-192">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-193">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-blue-100" data-id="element-194" />

              <div className="flex items-center gap-1 mb-4" data-id="element-195">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-196" />)}
              </div>

              <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-197">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-198">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold" data-id="element-199">
                  {t.initial}
                </div>
                <div data-id="element-200">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-201">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-202">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-203">
          <CTAButton text="QUIERO MI PACK AHORA" data-id="element-204" />
        </div>
      </div>
    </section>;
}